module.exports = __webpack_public_path__ + "img/project9_10.png.82bc84fe.webp";